import React,{useState,useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserPlus,faUserMinus} from "@fortawesome/free-solid-svg-icons";
import Select from 'react-select'
import {Form,Row,Col} from "react-bootstrap";
import ListadoArchivosFicha from './ListadoArchivosFicha';
import ListadoSesionesFicha from './ListadoSesionesFicha';
import ListadoParticipacionesGrupalesFicha from './ListadoParticipacionesGrupalesFicha';
export const FichaControl = ({Codigo,Valor,Tipo,Opciones,Schemas,Nombre,Evento,EventoSel,NroElemento=null,EsAdicionable=0,ActualizarCompleto}) => {
    let opcionesSelector=[];
      Opciones?.map((elem)=>{
            opcionesSelector.push(
                {
                    value:elem.Valor,
                    label:elem.Nombre,
                    index:NroElemento
                }
            )
      });
                 
        const [ValorControl,setValor]=useState();
        useEffect(() => {
            async function setValorControl(){
                setValor(Valor);
            };
            setValorControl();             
        }, [Valor]);
      
      const actualizarValor= event => {
       
        if(event.target.className=='form-check-input'){
            setValor(event.target.checked);
        }
        else{
            setValor(event.target.value)
        }
      }
      const actualizarValorSelector= event => {
       
        if(Array.isArray(event)){           
            let valorArreglo=[];
            for(var i=0;i<event.length;i++){
                valorArreglo.push(event[i].value)
              }
            setValor(JSON.stringify(valorArreglo));
        }
        else{
            setValor(event.value);
        }
      }
      const agregarNuevoElemento = () => {
        const valorObjeto= JSON.parse(ValorControl);
        let atributos=Object.values(valorObjeto);
        let keys=Object.keys(valorObjeto);
        let objetoPorSetear={};
        for(let h=0;h<atributos.length;h++)
        {
            let valorAnterior=JSON.parse(atributos[h]);
            const indiceNuevoValor=valorAnterior.length;
            valorAnterior.push(
                {
                    valor:"",
                    nroElemento:indiceNuevoValor.toString()
                    
                }
            );
            const valorNuevo=JSON.stringify(valorAnterior);
            atributos[h]=valorNuevo;
            objetoPorSetear[keys[h]]=valorNuevo;
        }
            setValor(JSON.stringify(objetoPorSetear));
        };

       
       const quitarElemento = (nroElemento) => {
        
        let valorObjeto= JSON.parse(ValorControl);
        let atributos=Object.values(valorObjeto);
        let keys=Object.keys(valorObjeto);
        for(let h=0;h<atributos.length;h++)
        {
            let valorPrevio=JSON.parse(atributos[h]);
            let valorNuevo=valorPrevio.filter(p=>p.nroElemento!=nroElemento);
            for(let i=0;i<valorNuevo.length;i++)
            {
                valorNuevo[i].nroElemento=i;
            }
            valorObjeto[keys[h]]=JSON.stringify(valorNuevo);
        }
        setValor(JSON.stringify(valorObjeto));
        ActualizarCompleto(Codigo,JSON.stringify(valorObjeto));
        
        };

    if(Tipo=='sel'){
        return (
        <>
        <Col xs="6">
            <label>{Nombre}</label>
            <Select
            placeholder='Selecciona una opción' 
            name={Codigo}
            options={opcionesSelector}
            className="basic-single"
            classNamePrefix="select"
            value={ opcionesSelector.filter(i=>{ 
                    return i.value==ValorControl;
                })
            }
            onChange={
                (e,prop) => { actualizarValorSelector(e); EventoSel(e,prop) }
            }
            
            />
        </Col>
         </>
        )
    }
    else if(Tipo=='selmulti'){
        return (
            <>
            <Col xs="6">
            <label>{Nombre}</label>
            <Select
            placeholder="Seleccione una o más opciones"
            isMulti
            name={Codigo}
            options={opcionesSelector}
            value={opcionesSelector.filter(i=>{ 
               
                return ValorControl!=null && ValorControl!=undefined && ValorControl?.includes(`"${i.value}"`);
              })}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={
                (e,prop) => { actualizarValorSelector(e); EventoSel(e,prop) }
            }
            />
            </Col>
            </>
        )
    }
    else if(Tipo=='txt'){
        return ( 
            <>
            <Col xs="6">
            <label>{Nombre}</label>
            <Form.Control
            id={Codigo}
            name={Codigo}
            value={ValorControl}
            placeholder=""
            type="text"
            onChange={
                e => { actualizarValor(e); Evento(e) }
            }
            data-nroelemento={NroElemento}
            
          ></Form.Control>
          </Col>
          </>
        )
    }
    else if(Tipo=='auto'){
        return ( 
            <>
            <Col xs="6">
            <label>{Nombre}</label>
            <Form.Control
            id={Codigo}
            name={Codigo}
            value={ValorControl}
            placeholder=""
            type="text"
            disabled
            data-nroelemento={NroElemento}
           
          ></Form.Control>
          </Col>
          </>
        )
    }
    else if(Tipo=='email'){
        return ( 
            <>
            <Col xs="6">
            <label>{Nombre}</label>
            <Form.Control
            id={Codigo}
            name={Codigo}
            value={ValorControl}
            placeholder=""
            type="email"
            onChange={
                e => { actualizarValor(e); Evento(e) }
            }
            data-nroelemento={NroElemento}
            
          ></Form.Control>
          </Col>
          </>
        )
    }
    else if(Tipo=='bigtxt'){
        return ( 
            <>
            <Col xs="6">
            <label>{Nombre}</label>
            <Form.Control
            id={Codigo}
            name={Codigo}
            value={ValorControl}
            placeholder=""
            type="textarea"
            as="textarea"
            rows={6}
            onChange={
                e => { actualizarValor(e); Evento(e) }
            }
            data-nroelemento={NroElemento}
            
          ></Form.Control>
          </Col>
          </>
        )
    }
    else if(Tipo=='num'){
        return ( 
            <>
            <Col xs="6">
            <label>{Nombre}</label>
            <Form.Control
            id={Codigo}
            name={Codigo}
            value={ValorControl}
            placeholder=""
            type="number"
            onChange={
                e => { actualizarValor(e); Evento(e) }
            }
            data-nroelemento={NroElemento}
            
          ></Form.Control>
          </Col>
          </>
        )

    }
    else if(Tipo=='date'){
        return (
            <>
            <Col xs="6">
            <label>{Nombre}</label>
            <Form.Control              
                placeholder=""
                type="date"
                name={Codigo}
                value={ValorControl?.substring(0,10)}
                onChange={
                    e => { 
                        actualizarValor(e); 
                        Evento(e);
                    }
                }
                data-nroelemento={NroElemento}
                
            ></Form.Control>
            </Col>
            </>
        )
    }
    else if(Tipo=='multiple'){        
        return (
        <>
        <Col xs="12">
            <label>{Nombre}</label>
                {
                    EsAdicionable==1 &&
                    <button type='button' className='btnBuscar'
                    onClick={(e)=>{
                        e.preventDefault();
                        agregarNuevoElemento();}}>
                    <FontAwesomeIcon icon={faUserPlus} />
                    </button>
                }
            {       
                Schemas?.map((schema,index0) =>{
                let elementos=[];
                if(ValorControl==undefined){
                    return;
                }
                const valorAEnviar=JSON.parse(ValorControl);
                if(valorAEnviar==null){
                    return;
                }
                let nroElem=1;
                try{
                    const valorArr= Object.values(valorAEnviar)[0];
                        if(Array.isArray(JSON.parse(valorArr))){
                            nroElem=JSON.parse(valorArr).length;
                        }
                        else{
                            nroElem=1;
                        }
                    }
                    catch(err){
                    }
                    for(let h=0;h<nroElem;h++)
                    {
                        if(nroElem>1 ){
                            elementos.push(
                            <Row>
                            <Col xs="6" style={{textAlign:'right'}}>
                            <button type='button' className='btnBuscar'
                                onClick={(e)=>{
                                e.preventDefault();
                                quitarElemento(h);}}>
                                <FontAwesomeIcon icon={faUserMinus} />
                            </button>
                            </Col>
                            </Row>
                        );
                        }
                       
                        schema?.map((elem,index) => { 
                            if(valorAEnviar[elem.Codigo]!=undefined){
                               
                                if(elem.Tipo!='multiple'){
                                    
                                    const arregloValor=JSON.parse(valorAEnviar[elem.Codigo]);
                                    let objetoValor="";
                                   
                                    let indiceNroElemento=h;
                                    if(Array.isArray(arregloValor)){
                                        if(arregloValor[h]?.valor!=undefined){
                                            if(elem.Tipo=='selmulti'){
                                                objetoValor=JSON.stringify(arregloValor[h].valor);
                                                indiceNroElemento=arregloValor[h].nroElemento;
                                            }
                                            else
                                            {
                                                objetoValor=arregloValor[h].valor;
                                                indiceNroElemento=arregloValor[h].nroElemento;
                                            }
                                        }
                                      
                                    }
                                    else{
                                        
                                        objetoValor=arregloValor;
                                    }
                                    elementos.push(
                                            <Row>
                                            <Col>
                                                <FichaControl 
                                                key={(elem.Codigo+h).toString()}
                                                Codigo={elem.Codigo}
                                                Tipo={elem.Tipo}
                                                Opciones={elem.Opciones}
                                                Schemas={elem.Schemas}
                                                Nombre={elem.Nombre}
                                                Evento={Evento}
                                                EventoSel={EventoSel}
                                                EsAdicionable={elem.EsAdicionable}
                                                NroElemento={(indiceNroElemento).toString()}
                                                Valor={objetoValor}
                                                ActualizarCompleto={ActualizarCompleto}
                                                />
                                            </Col>
                                            </Row>
                                        )
                                }
                                else{
                                    const arregloValor=valorAEnviar[elem.Codigo];                       
                                    const objetoValor=JSON.stringify(arregloValor);
                                    elementos.push(
                                        <Row>
                                        <Col>
                                            <FichaControl 
                                                key={(elem.Codigo+h).toString()}
                                                Codigo={elem.Codigo}
                                                Tipo={elem.Tipo}
                                                Opciones={elem.Opciones}
                                                Schemas={elem.Schemas}
                                                Nombre={elem.Nombre}
                                                Evento={Evento}
                                                EventoSel={EventoSel}
                                                EsAdicionable={elem.EsAdicionable}
                                                NroElemento={(h).toString()}
                                                Valor={objetoValor}
                                                ActualizarCompleto={ActualizarCompleto}
                                            />
                                        </Col>
                                        </Row>
                                        )
                                }
                            }
                            else{
                               
                            elementos.push(
                                <Row>
                                <Col>
                                    <FichaControl 
                                    key={(elem.Codigo+h).toString()}
                                    Codigo={elem.Codigo}
                                    Tipo={elem.Tipo}
                                    Opciones={elem.Opciones}
                                    Schemas={elem.Schemas}
                                    Nombre={elem.Nombre}
                                    Evento={Evento}
                                    EventoSel={EventoSel}
                                    EsAdicionable={elem.EsAdicionable}
                                    NroElemento={(h).toString()}
                                    
                                    ActualizarCompleto={ActualizarCompleto}
                                    />
                                </Col>
                                </Row>
                            );
                            }
                        })
                    }
                return elementos;
            })
        }
        </Col>
        </>
         );
    }
    else if(Tipo=='custom' && (Codigo=='DocumentosAdjuntos')){
        return ( 
            <>
            <Col xs="12">
            
           <ListadoArchivosFicha></ListadoArchivosFicha>
            </Col>
          </>
        )
    }
    else if(Tipo=='custom' && (Codigo=='Sesiones' )){
        return ( 
            <>
            <Col xs="12">
            <label>{Nombre}</label>
           <ListadoSesionesFicha></ListadoSesionesFicha>
            </Col>
          </>
        )
    }
    else if(Tipo=='custom' && (Codigo=='ParticipacionGrupal')){
        
        return ( 
            <>
            <Col xs="12">
            <label>{Nombre}</label>
           <ListadoParticipacionesGrupalesFicha></ListadoParticipacionesGrupalesFicha>
            </Col>
          </>
        )
    }
    else if(Tipo=='custom' && (Codigo=='AGenograma' )){
         //nuevo
         const [image, setImage] = useState(() => sessionStorage.getItem("uploadedImage") || "");

         const handleImageUpload = (event) => {
           const file = event.target.files[0];
           if (file && file.size <= 2 * 1024 * 1024) { // Limite de 2MB
             const blobUrl = URL.createObjectURL(file);
             setImage(blobUrl);
             sessionStorage.setItem("uploadedImage", blobUrl);
           } else {
             alert("El archivo es demasiado grande. Máximo permitido: 2MB");
           }
         };
       
        return ( 
            <>

            <Col xs="12">
            <label>{Nombre}</label>
            <div className="flex flex-col items-center p-4 border rounded-lg shadow-lg">
      <input type="file" accept="image/*" onChange={handleImageUpload} className="mb-4" />
      {image && <img src={image} alt="Uploaded" className="w-48 h-48 object-cover rounded-lg" />}
    </div>
            </Col>
          </>
        )
    }
    else{
        return (
            <></>
        )
    }
}
